export const password = [
  { required: true, message: "请输入密码" },
  {
    max: 32,
    min: 6,
    message: "密码长度必须为6-32个字符",
  },
];

export const username = [
  { required: true, message: "请输入昵称" },
  {
    message: "昵称长度限制为2～10个中文或者4～20个英文字符",
    validator(_, value = "") {
      // eslint-disable-next-line no-control-regex
      const byteLenth = value.replace(/[^\x00-\xff]/g, "aa").length;
      if (byteLenth > 20 || (byteLenth < 4 && byteLenth > 0)) {
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
  },
  {
    message: "昵称不能包含@、#、$ 以及空格等特殊字符",
    validator(_, value) {
      if (/[@\s#$]/.test(value)) {
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },
  },
];

export const telAndEmail = [
  { required: true, message: "请输入手机号或者邮箱" },
];

export const tel = [{ required: true, message: "请输入手机号" }];

export const accept = [{ required: true, message: "请勾选接受协议" }];

export const captcha = [{ required: true, message: "请输入验证码" }];

export const job = [{ required: true, message: "请选择职业" }];

const rules = {
  password,
  username,
  accept,
  captcha,
  tel,
  telAndEmail,
  job,
};

export default rules;
